import * as z from "zod";

export const reportRecoverIssue = {
  name: "reportRecoverIssue" as const,
  input: z.object({
    teamId: z.string(),
    teamName: z.string().optional(),
    conversationId: z.string(),
    customerName: z.string().optional(),
    reason: z.string().optional(),
    authEmail: z.string(),
    /** JPEG data URL captured from the reporter's browser. */
    screenshotDataUrl: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
